import { Button, Dialog, Typography } from '@mui/material'
import { InfoCardIcon } from 'components/atoms/Icons'
import InCardStack from 'components/atoms/container/InCardStack'
const InfoDialog = ({
  open,
  onClose,
  title,
  children,
  icon,
  buttonText,
  maxWidth = 'sm',
  ...props
}) => {
  return (
    <Dialog onClose={onClose} open={open} maxWidth={maxWidth} {...props}>
      <InCardStack padding={20} style={{ textAlign: 'center' }}>
        {icon && <InfoCardIcon src={icon} />}
        {title && <Typography variant='h1'>{title}</Typography>}
        {children}
        <Button onClick={onClose}>{buttonText}</Button>
      </InCardStack>
    </Dialog>
  )
}

export default InfoDialog
